import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BrandBriefPopup = loadAsyncComponent(() => import('./Container'), 'popup');
